var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import SamplesUtil from '../../utils/samplesUtil';
import Icons from '../Icons/Icons';
const handleize = (string) => {
    return string.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
};
const calculateAllowedSamples = (cartItems, samples) => {
    var _a;
    let totalSamples = 0;
    for (const item of cartItems) {
        const sample = samples.find((s) => s.current_variant.id === item.variant_id);
        if (!!sample)
            continue;
        const receiveComplimentary = ((_a = item.metafields) === null || _a === void 0 ? void 0 : _a.receive_complimentary) || 0;
        totalSamples += receiveComplimentary * item.quantity;
    }
    return Math.min(totalSamples, 6);
};
const Banner = ({ cartItems, settings, loadingSamples, hideCounterBeforeLoad = false }) => {
    const [samples, setSamples] = useState([]);
    const allowedSamples = calculateAllowedSamples(cartItems, samples);
    useEffect(() => {
        const fetchSamples = () => __awaiter(void 0, void 0, void 0, function* () {
            const samples = yield SamplesUtil.getSampleProducts('active-samples');
            setSamples(samples);
        });
        fetchSamples();
    }, []);
    const samplesInCart = cartItems.filter((item) => samples.some((sample) => sample.current_variant.id == item.variant_id));
    const selectedCount = samplesInCart.length;
    let title = settings.bannerMessageEmpty;
    console.log(`samples in cart: ${samplesInCart.length}, selected count: ${selectedCount}, allowed samples: ${allowedSamples}`);
    if (samplesInCart.length > 0 && allowedSamples > 0) {
        if (loadingSamples) {
            title = settings.bannerMessageSelected.replace('(count)/(allowed)', `<span style="visibility: hidden;">${selectedCount}/${allowedSamples}</span>`);
        }
        else {
            title = settings.bannerMessageSelected.replace('(count)', selectedCount.toString()).replace('(allowed)', allowedSamples.toString());
        }
    }
    else if (allowedSamples > 0 && selectedCount == 0) {
        if (loadingSamples) {
            title = settings.bannerMessagePrompt.replace('(allowed) x', `<span style="visibility: hidden;">${allowedSamples} x</span>`);
        }
        else {
            title = settings.bannerMessagePrompt.replace('(allowed)', allowedSamples.toString());
        }
        if (allowedSamples > 1) {
            title = title.replace('Sample', 'Samples');
        }
    }
    let titleClass = 'samples-banner__title';
    if (allowedSamples > 0 && selectedCount == 0) {
        titleClass += ' samples-banner__title--prompt';
    }
    return (React.createElement("div", { className: "samples-banner" }, !!hideCounterBeforeLoad && samples.length === 0 ? React.createElement(React.Fragment, null) : (React.createElement("h3", { className: titleClass },
        React.createElement("span", { dangerouslySetInnerHTML: { __html: title } }),
        loadingSamples && React.createElement(Icons.Loading, null)))));
};
export default Banner;
